var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 2.398a2.6 2.6 0 0 1 2.6 2.6v14a2.6 2.6 0 0 1-2.6 2.6H5a2.6 2.6 0 0 1-2.6-2.6v-14a2.6 2.6 0 0 1 2.6-2.6zm-2.5 9.428a1.5 1.5 0 0 0-1.06.44l-8.133 8.132H19a1.4 1.4 0 0 0 1.4-1.4v-3.893l-2.84-2.84a1.5 1.5 0 0 0-1.06-.439M5 3.598a1.4 1.4 0 0 0-1.4 1.4v14a1.4 1.4 0 0 0 1.4 1.4h.893l8.84-8.84a2.5 2.5 0 0 1 3.535 0l2.132 2.133V4.998a1.4 1.4 0 0 0-1.4-1.4zm4 2.9a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
  })));
};
export default SvgImage;